module.exports = __webpack_public_path__ + "img/login-bg.10240f47.svg";